import { createFileRoute } from '@tanstack/react-router'
import { MembersContainer } from '@/components/team/members-container'
import { RowsSkeleton, ViewBarSkeleton } from '@/components/shell/screen-skeletons'

export const Route = createFileRoute('/o/$org/members')({
  pendingComponent: () => (
    <>
      <ViewBarSkeleton />
      <RowsSkeleton />
    </>
  ),
  component: MembersContainer,
})
